module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "uk-navbar-container",
    attrs: {
      "uk-navbar": ""
    }
  }, [_c('div', {
    staticClass: "uk-navbar-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "navlogo pb-2",
    attrs: {
      "src": require("../../CUSTOM/assets/logo.png")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', {
    staticClass: "uk-margin-small-left uk-visible@s"
  }, [_vm._v(_vm._s(_vm.$store.state.core.config.generalData.displayName || ''))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-right"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', [(_vm.$store.state.core.user) ? _c('div', {
    staticClass: "uk-inline"
  }, [_c('div', [_c('img', {
    staticClass: "round uk-margin-small-right",
    attrs: {
      "src": _vm.$store.state.core.user.photoURL,
      "width": "40"
    }
  }), _c('span', {
    staticClass: "uk-visible@m uk-margin-small-right"
  }, [_vm._v(_vm._s(_vm.$store.state.core.user.displayName))])]), _vm._v(" "), _c('div', {
    attrs: {
      "uk-dropdown": "pos: bottom-justify"
    }
  }, [_c('ul', {
    staticClass: "uk-nav uk-dropdown-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "profile"
    }
  }, [_vm._v("Profiel")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "uk-text-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Afmelden")])])])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca52b40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/components/AppHeader.vue
// module id = 511
// module chunks = 1